'use client'

import { CustomerStory } from '@interfaces/brandHub'
import React from 'react'
import Image from 'next/image'
import { useAnimateOnVisible } from '@hooks/useAnimateOnVisible'
import RatingStars from '@components/CustomerStory/RatingStars/RatingStars'
import { Colors } from '@enums/Colors'
import styles from './CustomerStoryCard.module.scss'

interface CustomerStoryCardProps {
  story: CustomerStory
}

const CustomerStoryCard = ({ story }: CustomerStoryCardProps) => {
  const { ref, animationClassName } = useAnimateOnVisible<HTMLDivElement>()
  return (
    <div ref={ref} className={`${styles.customerStoryCard} ${animationClassName}`}>
      <div className={styles.storyContainer}>
        <RatingStars
          rating={story.rating ?? 5}
          total={5}
          starColor={Colors.StarColor}
          starBackgroundColor={Colors.StarBgColor}
        />
        <p className={styles.story}>{story.story}</p>
      </div>
      <div className={styles.customerProfile}>
        {story.customerProfile?.data ? (
          <Image
            className={styles.customerProfileImg}
            src={story.customerProfile.data.attributes?.url}
            alt="Customer Profile"
            height={56}
            width={56}
          />
        ) : (
          <p className={styles.customerProfileLetterImg}> {story.customerName.charAt(0).toUpperCase()}</p>
        )}
        <div className={styles.customerDetail}>
          <p className={styles.customerName}>{story.customerName}</p>
          <p className={styles.customerTitle}>{story.customerTitle}</p>
        </div>
      </div>
    </div>
  )
}

export default CustomerStoryCard
